/**
 * Shorthand for the window.performance.measure()
 *
 * @param {string} fromEvent The start event fofor the measurement
 * @param {string} toEvent The end event of the measurement
 * @returns {number|null} the duration of the event, or null
 */
export function sendPerformanceMeasure(
  eventName,
  prevEvent = null,
  debug = false,
  detail = {}
) {
  try {
    const measure = window.performance.measure(`time-to-${eventName}`, {
      start: prevEvent,
      end: eventName,
      /* NOTE - anything included in detail must be string -
        detail = {
          nodeId: 'xxx',
          abVariant: 'abc',
          isAutoplay: 'true',
          ...
        }
      */
      detail: { ...detail }
    });

    if (debug) {
      console.log(measure);
    }

    // Zeus metric only take integer
    return Math.round(measure.duration);
  } catch (err) {
    return null;
  }
}

/**
 * Shorthand for the window.performance.mark()
 *
 * @param {string} eventName event name
 * @param {debug} boolean debug flag
 * @param {object} detail additional detail to be added to the performance mark
 * @returns The performance mark object
 */
export function sendPerformanceEvent(eventName, debug = false, detail = {}) {
  if (typeof window === "undefined" || window.performance.mark === undefined) {
    return;
  }
  const mark = window.performance?.mark(eventName, {
    /* NOTE - anything included in detail must be string -
      detail = {
        nodeId: 'xxx',
        abVariant: 'abc',
        isAutoplay: 'true',
        ...
      }
    */
    detail: detail
  });
  if (debug) {
    console.log(mark);
  }
  return mark;
}
